import { render } from "./ModalPrompt.vue?vue&type=template&id=1320af96"
import script from "./ModalPrompt.vue?vue&type=script&lang=js"
export * from "./ModalPrompt.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brianng/Desktop/supa/ionic/SupaFoundation/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])